import React from 'react';
import get from 'lodash/get';
import { AdsClickIcon, LinkIcon } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import SectionHeaderAndSubtitle from '../SectionHeaderAndSubtitle/SectionHeaderAndSubtitle';
import styles from './conversionTypeHeader.module.scss';

export const getEventName = event => {
    if (!event) {
        return '';
    }

    const displayText = get(event, 'trackedElements[0].displayText');

    return displayText || event.eventName || '';
};

export const ConversionTypeHeader = ({ event }) => {
    const isButtonClicks = event.type === CONVERSION_TYPE.EVENT_BASED;
    const urlEvent = event.urlEvent || event.condition?.value;
    const displayEventName = getEventName(event);
    const category = event.category?.value || event.category;

    return (
        <SectionHeaderAndSubtitle
            headerIcon={isButtonClicks ? <AdsClickIcon /> : <LinkIcon />}
            iconClassName={styles['icon-wrapper']}
            headerText={<FormattedMessage id={`tracking.conversion.category.${category}`} defaultMessage={category} />}
            subtitleText={
                isButtonClicks ? (
                    <FormattedMessage
                        id="codeless.conversion.button.event"
                        defaultMessage="Button click - `{eventName}`"
                        values={{ eventName: displayEventName }}
                    />
                ) : (
                    <FormattedMessage
                        id="codeless.conversion.url.event"
                        defaultMessage="URL visits -`{urlEvent}`"
                        values={{ urlEvent }}
                    />
                )
            }
        />
    );
};
